import curd from '../curd'

const BASE_PATH = '/device/status/connector'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/DeviceStatus.js